import styled from "styled-components";
import Flex from "./Flex";

export const FlexComponentSpaceBetween = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.xs} {
        justify-content: space-between;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        justify-content: space-between;
        align-items: center;
    }
`;

export const FlexComponentSpaceEvenly = styled(Flex)`
    justify-content: space-evenly;
    flex-wrap: wrap;
`;

export const FlexComponentCenter = styled(Flex)`
    justify-content: center;

    ${({ theme }) => theme.mediaQueries.xs} {
        margin: 20px 0px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        margin: unset;
    }
`;

export const FlexComponentPadding = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.sm} {
        padding: 50px 0px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        padding: 100px 0px 70px 0px;
    }
`;

export const FlexComponentWidth = styled(Flex)`
    width: 100%;
`;

export const FlexComponentAround = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.xs} {
        padding: 10px 0px 50px 0px;
        justify-content: space-between;
    }

    ${({ theme }) => theme.mediaQueries.md} {
        padding: 70px 0px;
    }
`;

export const FlexComponentCenterCenter = styled(Flex)`
    justify-content: center;
    align-items: center;
`;

export const FlexComponentFooterSpaceEvenly = styled(Flex)`
    justify-content: space-evenly;
    padding: 50px 0px 100px 0px;
`;

export const FlexComponentFooterCenter = styled(Flex)`
    justify-content: center;
    padding: 100px 0px;
`;

export const FlexComponentFooterSpaceBetween = styled(Flex)`
    justify-content: space-between;
    padding: 75px 0px;
`;

export const FlexComponentFooterDirectionColumn = styled(Flex)`
    flex-direction: column;
`;
